export default __webpack_public_path__ + "static/media/phone.20539e5a.svg";